import React from 'react';
import { SUBSCRIPTIONS_UPDATED, WebhookSubscription, useWebhookSubscriptionsService } from 'nekst-api';
import { Cell, List, ListDataRefresher, useShowContextRequired } from 'ui-builder';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { CreateWebhookSubscriptionButton } from './CreateWebhookSubscriptionForm';
import { GridLayout, IconDeleteButton } from 'features/nekst-widgets';
import TextField from '../../shared/uibuilder/show/field/TextField';
import { useSubscriptionEventHelper } from './subscriptionEventHelper';

function DeleteWebhookSubscriptionButton() {
  const showContext = useShowContextRequired<WebhookSubscription>();
  const webhookSubscriptionsService = useWebhookSubscriptionsService();

  return (
    <IconDeleteButton
      deleteFunc={async () => {
        await webhookSubscriptionsService.cancelSubscription(showContext.data!.id);
      }}
      message={`Are you sure you want to delete this webhook subscription?`}
    />
  );
}


function EventTypeField() {
  const showContext = useShowContextRequired<WebhookSubscription>();

  const subscriptionEventHelper = useSubscriptionEventHelper();

  return (
    <>{subscriptionEventHelper.getLabel(showContext.data!.eventType)}</>
  );
}

export default function WebhookSubscriptionsList() {
  const webhookSubscriptionsService = useWebhookSubscriptionsService();

  return (
    <InnerBlock title="Webhook Subscriptions" headerRight={<CreateWebhookSubscriptionButton />}>
      <List getDataFunc={webhookSubscriptionsService.getSubscriptions}>
        <GridLayout
          weights={[4, 3, 2, 2, 1]}
          noDataMessage="No webhook subscriptions configured."
        >
          <TextField source="webhookUrl" label="Webhook URL" />
          <Cell label="Event Type">
            <EventTypeField />
          </Cell>
          <Cell label="Status">
            {(item: WebhookSubscription) => (
              item.isEnabled ? 'Enabled' : 'Disabled'
            )}
          </Cell>
          <Cell label="Actions">
            <DeleteWebhookSubscriptionButton />
          </Cell>
        </GridLayout>
        <ListDataRefresher eventName={SUBSCRIPTIONS_UPDATED} />
      </List>
    </InnerBlock>
  );
} 